/*
This is the standard entry Point
This file wait for the page loaded (loading screen) to dynamicaly import the aaplication
This is needed to have the quick respond time (Time to Show)
*/

window.onload = (event) => {
    console.log('Page Loaded => Loading integrated BL');

    //Import system and start
    import("./integratedBL.js").then((module) => {
        console.log('Integrated BL Loaded');
        module.default();
    });
};